
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ar",
  "zh",
  "de",
  "ru",
  "hi",
  "es",
  "fr",
  "th",
  "uk"
]

export const localeLoaders = {
  "en": [],
  "ar": [],
  "zh": [],
  "de": [],
  "ru": [],
  "hi": [],
  "es": [],
  "fr": [],
  "th": [],
  "uk": []
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "name": "English"
    },
    {
      "code": "ar",
      "name": "عربي"
    },
    {
      "code": "zh",
      "name": "简体中文"
    },
    {
      "code": "de",
      "name": "Deutsch"
    },
    {
      "code": "ru",
      "name": "Русский"
    },
    {
      "code": "hi",
      "name": "हिंदी"
    },
    {
      "code": "es",
      "name": "Español"
    },
    {
      "code": "fr",
      "name": "Français"
    },
    {
      "code": "th",
      "name": "ภาษาไทย"
    },
    {
      "code": "uk",
      "name": "українська"
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "name": "English",
    "files": []
  },
  {
    "code": "ar",
    "name": "عربي",
    "files": []
  },
  {
    "code": "zh",
    "name": "简体中文",
    "files": []
  },
  {
    "code": "de",
    "name": "Deutsch",
    "files": []
  },
  {
    "code": "ru",
    "name": "Русский",
    "files": []
  },
  {
    "code": "hi",
    "name": "हिंदी",
    "files": []
  },
  {
    "code": "es",
    "name": "Español",
    "files": []
  },
  {
    "code": "fr",
    "name": "Français",
    "files": []
  },
  {
    "code": "th",
    "name": "ภาษาไทย",
    "files": []
  },
  {
    "code": "uk",
    "name": "українська",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
